module.exports = __webpack_public_path__ + "img/i5gam-mobile2.6de388ae.png";